<template>
      <h1>Se connecter</h1>
      <form action="" id="login" @submit.prevent="login">
        <label for="email">
            <p>Email</p>
            <input type="text" v-model="email" name="email" autofocus>
        </label>
        <label for="password">
            <p>Mot de passe</p>
            <div class="password-container">
              <input :type="showPassword ? 'text' : 'password'" v-model="password" name="password">
              <i class="material-icons toggle-password" @click.prevent="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</i>
            </div>
        </label>
        <div class="actions_login">
            <button type="submit" class="primary-button"><i class="material-icons">login</i>&nbsp;Connexion</button>
        </div>
        <button type="button" class="password_button" @click="ForgotPassword">Mot de passe oublié ?</button>
      </form>
      <div v-if="errorMessage">
        <br>
        <div class="danger-alert"><i class="material-icons">error</i>&nbsp; {{ errorMessage }}</div>
      </div>

</template>


<script setup>

import { ref }                      from 'vue'
import apiClient, { setAuthToken }  from '@/api'
import { useRouter, useRoute }      from 'vue-router'
import { useUserStore }             from '@/stores/userstore'

const userStore = useUserStore();

const emit      = defineEmits(['closeModal', 'forgot'])


const setToken  = userStore.setToken

const router    = useRouter()
const route     = useRoute()


const email        = ref('')
const password     = ref('')
const showPassword = ref(false)
const errorMessage = ref('')
// const router = useRouter()



const login = async () => {
  try {
    const response = await apiClient.post('token/', {
        email: email.value,
        password: password.value,
    })
    
    const { access, refresh } = response.data
    
    localStorage.setItem('accessToken', access)
    localStorage.setItem('refreshToken', refresh)
    
    // On update le reactive auth state dans composables
    userStore.setToken(access, refresh)

    // Set the access token in your Axios instance so that subsequent requests include it
    await setAuthToken(access)

    // 3) ✅ NEW — Ask backend to store access token into a cookie
    await apiClient.post('set-jwt-cookie/', {}, { withCredentials: true });


    //on ferme le modal
    emit("closeModal")
    
    // If there's a redirect, go there; otherwise, go home
    // pick the wiki origin from env; fallback to same-origin in prod
    const WIKI_ORIGIN =
      import.meta.env.VITE_WIKI_ORIGIN || window.location.origin;

    const redirectPath = route.query.redirect || '/';

    if (redirectPath.startsWith('/wiki')) {
      // Always go to the wiki origin (dev: 8080, prod: same domain over https)
      window.location.href = `${WIKI_ORIGIN}${redirectPath}`;
    } else {
      router.push(redirectPath);
    }


  } catch (error) {
    console.error('Login error:', error)
    errorMessage.value = 'Connexion échouée, vérifiez vos identifiants'
  }
}

const ForgotPassword= () => {
  emit('forgot')
}

</script>

<style lang="scss">
.actions_login{
    display: flex;
    flex-direction: row;
    justify-content: end;
    margin-top: 2rem;
}
.password_button {
  background: none;
  border: none;
  padding: 0;
  margin-top: 1rem;
  color: #3e80c3;
  font-size: 0.9rem;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
}

.password-container {
  position: relative;
}

.password-container input {
  width: 100%;
  padding-right: 40px;
  box-sizing: border-box;
}

.password-container .toggle-password {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    color: $orange
  }
}

</style>